import { Map } from 'immutable';

export default Map({
  showModal: false,
  bodyClass: null,
});
